import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuoteExtraService {

  private services = new BehaviorSubject<[]>([]);
  private document = new BehaviorSubject<boolean>(false);

  constructor() { }

  sendServices(services: []) {
    this.services.next( services );
  }

  getServices(): Observable<[]>{
    return this.services.asObservable();
  }

  sendDocument(doc) {
    this.document.next( doc );
  }

  getDocument(): Observable<boolean>{
    return this.document.asObservable();
  }
}
